module.exports = __webpack_public_path__ + "static/media/18ECA30.a5de8949.jpg";